import React from 'react';
import Routes from './Routes';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/index.js';
import { AuthProvider } from './contexts/AuthContext';
import { CustomerPortalProvider } from './contexts/CustomerPortalContext';
import { LanguageProvider } from './contexts/LanguageContext';
import PermissionsRevokedBanner from './components/ui/PermissionsRevokedBanner';
import { ReadOnlyProvider } from './components/ui/ReadOnlyGuard';
import BillingSessionTracker from './components/BillingSessionTracker';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <LanguageProvider>
        <AuthProvider>
          <CustomerPortalProvider>
            <ReadOnlyProvider>
              <BillingSessionTracker />
              <PermissionsRevokedBanner />
              <Routes />
            </ReadOnlyProvider>
          </CustomerPortalProvider>
        </AuthProvider>
      </LanguageProvider>
    </I18nextProvider>
  );
}

export default App;
